<section>
  <div class="category-header" [class.minor]="minor">
    <div class="default" *ngIf="header || headerKey || headerButtons.length">
      <span>{{ header ?? (headerKey | locLabel) | capitalize }}</span>
      <div class="flex-row">
        <ng-container *ngFor="let button of headerButtons">
          <app-form-button [icon]="button.icon" [color]="button.color" [textKey]="button.labelKey" (click)="button.onClick()">
          </app-form-button>
        </ng-container>
      </div>
    </div>
    <ng-content select="[custom-header]" *ngIf="!header"></ng-content>
  </div>
  <mat-divider class="category-divider"></mat-divider>
  <div class="padded" [class.mobile]="rwdService.isSmallDevice">
    <ng-content></ng-content>
  </div>
</section>
